<div class="repeat-section">
  @if (props.label) {
    <label class="mat-body-strong">{{ props.label }}</label>
  }
  @if (props.description) {
    <p class="mat-caption">{{ props.description }}</p>
  }

  @for (field of field.fieldGroup; track field.key) {
    <div class="repeat-item mat-elevation-z1">
      <formly-field [field]="field" class="repeat-field wide-form-field"></formly-field>

      <!-- TODO: Implement Remove button
      <button matIconButton color="warn" aria-label="Remove field" (click)="removeField(field)">
        <mat-icon class="material-symbols-outlined">remove_circle</mat-icon>
      </button>
      -->
    </div>
  }

  <!-- TODO: Implement Add Button
  <div class="repeat-add">
    <button matButton="elevated" color="primary" type="button" (click)="addField()">
      <mat-icon class="material-symbols-outlined">add</mat-icon> {{ 'Add' }}
    </button>
  </div>
  -->
</div>
